export const ACRONYMS = ["cia", "cnpj", "cpf", "ltda", "me", "rg"];

export const PREPOSITIONS = [
	"a",
	"com",
	"da",
	"das",
	"de",
	"do",
	"dos",
	"e",
	"em",
	"na",
	"nas",
	"no",
	"nos",
	"o",
	"por",
	"sem",
];
